// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import networkIcon from "@/assets/icons/aop/network.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type NetworkIconProps = Omit<IconProps, "name">;

export function NetworkIcon(props: NetworkIconProps): React.ReactNode {
  return <Icon name={networkIcon} {...props} />;
}
